import React, {useState, useCallback} from "react"
import { Link } from 'gatsby';
import { AnchorLink } from "gatsby-plugin-anchor-links";

import Layout from "../components/layout"
import Seo from "../components/seo"
import { check } from "prettier";
import {openModal} from '../utils/Modal'
import ModalJob from '../components/ModalJob';
import ModalSignin from '../components/ModalSignin';
import ModalVideo from '../components/ModalVideo';

const Jobs = () => {
	const [filterMenuOpen, setFilterMenuOpen] = useState(false);

	const openFilter = useCallback(
		() => {
			setFilterMenuOpen((state) => !state);
		},
		[],
	)

	const [activeButton, setActiveButton] = useState([]);
	const [activeButton2, setActiveButton2] = useState('');

  const activateButton = useCallback((e) => {
    setActiveButton((state )=> (
			state.includes(e.target.value) ?
				activeButton.filter((c)=> c !== e.target.value ) :
				[...activeButton, e.target.value] 
			));
  }, [activeButton]);

  const activateButton2 = useCallback((e) => {
    setActiveButton2(e.target.value)
  }, [activeButton2]);

	return (
		<Layout>
			<Seo title="Jobs" />
			<main>
				<section className="jobs-hero">
					<span className="big-gradient-circle red-gradient small-gradient gradient-anim " />
					<div className="small-container">
						<div className="flex-row flex-reverse-mob">
							<div className="col-6 col">
								<h3 className="hero-heading">Search for your dream <span>jobs</span></h3>
								<p className="hero-content">Discover dream jobs curated just for you from all over the world....</p>
								<div className="flex-row no-margin">
									<AnchorLink to="/jobs/#jobs" className="button button-purple">
										Explore All Jobs
									</AnchorLink>
									<Link to="#!" className="button button-white " onClick={() => openModal(<ModalSignin />)}>
										Join Cliphire
									</Link>
								</div>
							</div>
							<div className="col-6 col pr-20-m">
								<img className="hero-image" src="/img/jobs/jobs-hero.jpg" alt=""/>
							</div>
						</div>
					</div>
				</section>
				<section className="jobs-main" id="jobs">
					<div className="gradient-container">
						<span className="big-gradient-circle gradient-anim " />
						<span className="big-gradient-circle green-gradient small-gradient gradient-anim " />
						<span className="big-gradient-circle red-gradient gradient-anim " />
					</div>
					<div className="small-container">
						<h5 className="yellow-heading">Jobs</h5>
						<h3>Recent new <span className="stroke">opportunities</span></h3>
						<div className="flex-row flex-reverse-mob">
							<div className="w-67 col">
								{[...Array(6).keys()].map(i => (<div key={i} className="job-card" >
								<button className="job-card-overlay" onClick={() => openModal(<ModalJob />)} />
									<div className="flex-row no-margin align-items-center mb-15">
										<img src="/img/jobs/google.svg" alt="" className="job-logo"/>
										<div className="job-heading">
											<h4>
												Product Manager
												<a href="#!" onClick={() => openModal(<ModalSignin />)}>
												<img className="star hidden-mobile" src="/img/jobs/star.svg" alt=""/></a>
											</h4>
											<p className="job-detail">Google &#183; Remote friendly &#183; Full-time</p>
										</div>
									</div>
									<div className="flex-row align-items-center">
										<p className="tag salary">
											<img src="/img/jobs/salary-icon.svg" alt=""/>
											1,00,000 - 2,20,000
										</p>
										<p className="tag location">
											<img src="/img/jobs/location-icon.svg" alt=""/>
											London, UK
										</p>
										<p className="tag experience">
											<img src="/img/jobs/experience-icon.svg" alt=""/>
											02+ years
										</p>
										<p className="tag opening">
											<img src="/img/jobs/opening-icon.svg" alt=""/>
											06 Openings
										</p>
									</div>
									<div className="flex-row no-margin justify-content-between border">
										<p className="job-footer hidden-mobile">Google is looking for a Product Manager with work... <a href="#!">Learn more</a></p>
										<a href="#!" className="button button-white watch-video-button" onClick={() => openModal(<ModalVideo />)} >
											<img src="/img/jobs/play-blue.png" alt="" />
										Watch desc...
										</a>
										<a href="#!" className="button button-white" onClick={() => openModal(<ModalSignin />)} >
											Apply
										</a>
									</div>
								</div>))}
								<div className="no-results" style={{display : "none"}}> 
									<img src="/img/jobs/no-results.jpg" alt="no results"/>
									<div className="no-results-text">
										<p>Uh-oh! Looks like there are no result founds.<br/>
										Try chaning your filters or <a href="#!">View All Jobs</a>
										</p>
									</div>
								</div>
							</div>
							<div className="w-28 col">
								<div className="flex-row">
									<div className="col-6">
										<button type="button" className="button button-white visible-mobile filter-button" onClick={openFilter}>
											<svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M9.25 8.5C9.44891 8.5 9.63968 8.57902 9.78033 8.71967C9.92098 8.86032 10 9.05109 10 9.25C10 9.44891 9.92098 9.63968 9.78033 9.78033C9.63968 9.92098 9.44891 10 9.25 10H4.75C4.55109 10 4.36032 9.92098 4.21967 9.78033C4.07902 9.63968 4 9.44891 4 9.25C4 9.05109 4.07902 8.86032 4.21967 8.71967C4.36032 8.57902 4.55109 8.5 4.75 8.5H9.25ZM11.25 4.25C11.4489 4.25 11.6397 4.32902 11.7803 4.46967C11.921 4.61032 12 4.80109 12 5C12 5.19891 11.921 5.38968 11.7803 5.53033C11.6397 5.67098 11.4489 5.75 11.25 5.75H2.75C2.55109 5.75 2.36032 5.67098 2.21967 5.53033C2.07902 5.38968 2 5.19891 2 5C2 4.80109 2.07902 4.61032 2.21967 4.46967C2.36032 4.32902 2.55109 4.25 2.75 4.25H11.25ZM13.25 0C13.4489 0 13.6397 0.0790175 13.7803 0.21967C13.921 0.360322 14 0.551088 14 0.75C14 0.948912 13.921 1.13968 13.7803 1.28033C13.6397 1.42098 13.4489 1.5 13.25 1.5H0.75C0.551088 1.5 0.360322 1.42098 0.21967 1.28033C0.0790175 1.13968 0 0.948912 0 0.75C0 0.551088 0.0790175 0.360322 0.21967 0.21967C0.360322 0.0790175 0.551088 0 0.75 0H13.25Z" fill="#28125B"/>
											</svg>
											Filters
										</button>
									</div>
									<div className="col-6 flex-row justify-content-center align-items-center">
										<button type="button" className="clear-filter visible-mobile">
											<img src="/img/jobs/circle-arrow.svg" alt=""/>
											Clear Filters
										</button>
									</div>
								</div>
								<div style={{ height: '100%' }}>
									<div className={`job-filter ${filterMenuOpen ? 'open' : ''}`}>
										<h4>Filter</h4>
										<input type="text" id="Job" placeholder="Enter Job.." name="Job"  onChange={activateButton2} />
										<div className="filter-tag">
											<p>Product Manager</p>
											<button/>
										</div>
										<div className="checkbox">
											<div className="flex-row no-margin align-items-center border-top">
												<input type="checkbox" name="full-time" id='full-time' value="full-time"  onChange={activateButton}/>
												<label htmlFor='full-time'>
														Full-time
												</label>
											</div>
										</div>
										<div className="checkbox">
											<div className="flex-row no-margin align-items-center">
												<input type="checkbox" name="internship" id='internship' value="internship" onChange={activateButton}/>
												<label htmlFor='internship'>
													Internship
												</label>
											</div>
										</div>
										<div className="checkbox">
											<div className="flex-row no-margin align-items-center">
												<input type="checkbox" name="part-time" id='part-time' value="part-time" onChange={activateButton}/>
												<label htmlFor='part-time'>
													Part-time
												</label>
											</div>
										</div>
										<div className="checkbox">
											<div className="flex-row no-margin align-items-center">
												<input type="checkbox" name="contract" id='contract' value="contract" onChange={activateButton}/>
												<label htmlFor='contract'>
													Contract
												</label>
											</div>
										</div>
										<div className="checkbox">
											<div className="flex-row no-margin align-items-center border-top">
												<input type="checkbox" name="video-description" id='video-description' value="video-description"  onChange={activateButton}/>
												<label htmlFor='video-description'>
												Video Description
												</label>
											</div>
										</div>
										<h4 className="border-top">Location</h4>
										<input type="text" id="Job" placeholder="Enter Location" name="Job" 
										onChange={activateButton2}/>
										<div className="checkbox">
											<div className="flex-row no-margin align-items-center ">
												<input type="checkbox" name="remote-friendly" id='remote-friendly' value="remote-friendly"  onChange={activateButton}/>
												<label htmlFor='remote-friendly'>
													Remote friendly
												</label>
											</div>
										</div>
										<Link to="#!" className={`button button-purple ${activeButton.length === 0 && activeButton2 ===''  ? 'button-disabled' : ''}`}>
											Apply Filter
										</Link>
										<button type="button" className="clear-filter hidden-mobile" style={{display: "none"}}>
											Clear Filters
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
						<Link to="/#!" className="button button-purple">
							View more jobs
						</Link>
				</section>
			</main>
		</Layout>
	)
}

export default Jobs